import { ComponentType } from "react";
import VerbachatIcon from "../../../../../../assets/svg/verbachat-icon";
import UserIcon from "../../../../../../assets/svg/user-icon";
import CalendarIcon from "../../../../../../assets/svg/calendar-icon";
import TasksIcon from "../../../../../../assets/svg/tasks-icon";
import TicketIcon from "../../../../../../assets/svg/ticket-icon";
import DocumentTextIcon from "../../../../../../assets/svg/document-text-icon";
import HomeIcon from "../../../../../../assets/svg/home-icon";
import { IconProps } from "../../../../../../utils/global-types/global-types";

// Matches vf-core's app/services/verbaiq/data_access.py::VERBAIQ_CATEGORIES exactly —
// keep both lists in sync if this set ever changes.
export const ALL_PROPERTIES_ACCESS_SENTINEL = "-1";

export interface VerbaiqCategoryConfig {
  id: string;
  label: string;
  icon: ComponentType<IconProps>;
  info: string;
}

export const VERBAIQ_CATEGORIES: VerbaiqCategoryConfig[] = [
  {
    id: "conversations",
    label: "Conversations",
    icon: VerbachatIcon,
    info: "Full conversation transcripts across every channel — chat, WhatsApp, email and SMS.",
  },
  {
    id: "leads",
    label: "Leads",
    icon: UserIcon,
    info: "Lead profile, stage and source. Not the raw conversation transcript — that's gated separately by Conversations, above.",
  },
  {
    id: "viewings",
    label: "Viewings",
    icon: CalendarIcon,
    info: "Booked, completed and cancelled viewings, including the assigned agent and the property.",
  },
  {
    id: "tasks",
    label: "Tasks",
    icon: TasksIcon,
    info: "Task records and their assignees, due dates and completion state.",
  },
  {
    id: "tickets",
    label: "Tickets",
    icon: TicketIcon,
    info: "Support tickets with status, priority and resolution time — not the ticket's message thread.",
  },
  {
    id: "documents",
    label: "Documents",
    icon: DocumentTextIcon,
    info: "Tenancy agreements, ID checks and uploaded files. Grant sparingly — these records often contain personal data.",
  },
  {
    id: "property",
    label: "Property access",
    icon: HomeIcon,
    info: "Property/PMS data — availability, pricing and inventory. Collection-level only for now: this does not yet restrict which specific properties.",
  },
];
